var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"text":""},on:{"click":_vm.onClick}},'v-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-close")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }